import { FC } from "react";
import { Pager } from "shared/ui";
import { useRaffleHistory } from "../../model/useRaffleHistory";
import { RaffleCardList } from "../RaffleCardList";

interface Props {
  onOpenRaffle: (raffleId: number) => void;
}

// Созданные и те, где участвовал; роль показывает бейдж на RaffleCard.
export const RaffleHistory: FC<Props> = ({ onOpenRaffle }) => {
  const history = useRaffleHistory();

  return (
    <>
      <RaffleCardList
        items={history.pageItems}
        emptyText="No promos yet"
        isLoading={history.isLoading}
        errorMessage={history.errorMessage}
        onOpenRaffle={onOpenRaffle}
      />
      <Pager
        page={history.page}
        pages={history.pages}
        onChange={history.setPage}
      />
    </>
  );
};
